@if ((loading$ | async) === true) {
  <div class="spinner m-auto mt-40 h-32 w-32 border-8"></div>
}

@if ((loading$ | async) === false) {
  <ng-container class="mb-4">
    <div class="relative mb-4 flex items-center">
      <aux-input
        class="w-48"
        placeholder="Search"
        icon="Search"
        iconPosition="left"
        hotKey="/"
        [(ngModel)]="nameFilterValue"
      />
      <div class="ml-4 mr-auto flex items-center">
        <div class="mr-2 text-sm">Vendor Contract</div>
        <aux-vendor-dropdown
          [showAllOption]="true"
          [vendors]="(organizationQuery.allVendors$ | async)!"
          [formControl]="selectedVendor"
          (onChange)="onOrganizationSelected($event)"
        />
      </div>
    </div>

    @if (showCOChart$ | async) {
      <div>
        @if (coChartLoading$ | async) {
          <div class="mt-15 spinner m-auto mb-10 h-16 w-16 border-8"></div>
        }
        @if ((coChartLoading$ | async) === false) {
          <div class="justify-center">
            <h1 class="flex h-11 items-center text-right text-aux-gray-darkest">
              Budget Changes over Time
            </h1>
          </div>
        }
        <canvas
          class="ml-auto px-2 pb-3"
          width="5"
          height="1"
          style="height: 400px"
          id="changeOrderLineChart"
          [hidden]="(coChartLoading$ | async) === false"
        ></canvas>
      </div>
    }

    <div class="mb-4 flex items-center justify-end">
      <button type="button" class="btn--primary mr-2" (click)="openChangerOrderUpload()">
        <aux-icon name="Plus" />
        <span class="ml-2">Create New</span>
      </button>
      <aux-export-excel-button
        [gridAPI]="gridAPI"
        [excelOptions]="excelOptions"
        [getDynamicExcelParamsCallback]="getDynamicExcelParams"
        pendoTag="change-order-excel-export-button"
      />
    </div>

    <div class="mb-8 w-full">
      <ag-grid-angular
        class="ag-theme-aux change-order-table w-full tabular-nums"
        domLayout="autoHeight"
        [rowData]="gridData$ | async"
        [gridOptions]="(gridOptions$ | async)!"
        [quickFilterText]="nameFilterValue"
        [overlayNoRowsTemplate]="overlayNoRowsTemplate"
        (gridReady)="onGridReady($event)"
        (firstDataRendered)="onFirstDataRendered()"
        auxStickyGrid
      />
    </div>
  </ng-container>
}
